import React from 'react';
import BPCheckbox from '../../../atoms/checkbox/bpcheckbox';
import Dialog from '../../dialog';
import { LoadingBlock } from '../../loading/progress';
import { Classes } from '@blueprintjs/core';
import { Container, Row, Col } from '../../../../grid';
import { ITag, useGetTags } from '../../../../libs/tag';

interface SelectTagsProps {
  isDialogOpen: boolean;
  toggleDialog: () => void;
  selected: ITag[];
  updateSelected: any;
}

const SelectTagsDialog: React.FC<SelectTagsProps> = ({
  isDialogOpen,
  toggleDialog,
  selected,
  updateSelected
}) => {
  const data = useGetTags({ list: true }, isDialogOpen);
  const tags = data && data.tags ? data.tags : null;
  const selectedIds = selected ? selected.map((tag) => tag.id) : [];
  const isLoading = data && data.isLoading ? data.isLoading : false;

  const toggleSelected = (tagId: number) => {
    let updated: number[];
    if (selectedIds.includes(tagId)) {
      updated = selectedIds.filter((selectedId) => selectedId !== tagId);
    } else {
      updated = selectedIds.concat(tagId);
    }
    updateSelected('filters.tagIds', updated);
  };

  return (
    <Dialog
      title="Select Tags Filter"
      isOpen={isDialogOpen}
      onClose={toggleDialog}
      forceScrollY
    >
      <div className={Classes.DIALOG_BODY}>
        {isLoading ? (
          <LoadingBlock />
        ) : (
          <React.Fragment>
            <p>If you do not want to filter against tags, do not select any.</p>
            <Container fluid>
              <Row>
                {tags &&
                  tags.map((tag) => (
                    <Col key={tag.id} md={8}>
                      <BPCheckbox
                        label={tag.value}
                        checked={selectedIds.includes(tag.id)}
                        onClick={() => toggleSelected(tag.id)}
                      />
                    </Col>
                  ))}
              </Row>
            </Container>
          </React.Fragment>
        )}
      </div>
    </Dialog>
  );
};

export default SelectTagsDialog;
